/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';
// FIXME: Review after the merge
class InlineEditMultipleDropdownDirective {
    public restrict = 'E';
    public scope;
    public template;

    public newValue;
    public removeValue;
    public tempArr;
    public oldArr;

    public descIndex;

    constructor(private $timeout: any) {
        this.restrict = 'E';
        this.scope = {
            optionsArr: '=',
            saveFunc: '&?',
            selectArr: '=',
            descriptions: '=?',
            label: '@?',
            canEdit: '=?'
        };

        this.template = `
            <md-input-container class="w-100 mb-0" ng-class="{'md-input-has-placeholder': selectArr.length >= 1, 'md-input-focused': selectArr.length >= 1}">
                <label class="always-float">{{label}}</label>
                <md-select class="lh-initial capital-text", ng-model="newValue", ng-click="edit()" ng-change="addItem()", ng-disabled="canEdit == false">
                    <md-option class="capital-text", ng-repeat="o in optionsArr track by $index">
                        {{o}}
                    </md-option>
                </md-select>
            </md-input-container>
            <div class='field removeMargins p-l-5', ng-repeat="s in selectArr track by $index", ng-click="edit()">
                <div>
                    <div class="md-body-1 inlineBlock">
                        {{s}}
                    </div> 
                    <md-button class="md-icon-button md-primary float-right m-r-0" aria-label="Remove Item" ng-mousedown="removeItem($index)", ng-hide="canEdit == false">
                        <md-icon class="p-0" md-font-library="material-icons">close</md-icon>
                    </md-button> 
                </div> 
            </div>
        `;

    }

    public link($scope: any, $element: any, attrs: any): any {
        $scope.edit = function (): any {
            $scope.editing = true;
        };

        $scope.descCheck = function(index: any): any {
            if ($scope.descriptions !== undefined) {
                this.descIndex = $scope.descriptions.map(function(e: any): any { return e.name; }).indexOf(index);
            }
        };


        $scope.addItem = function (): any {
            // $scope.editing = false;
            for (var i: number = 0; i < $scope.selectArr.length; i++) {
                if (this.newValue === $scope.selectArr[i]) {
                    // $element.removeClass('active');
                    return;
                }
            }
            this.oldArr = angular.copy($scope.selectArr);
            $scope.selectArr.push(this.newValue);
            this.tempArr = $scope.selectArr;
            var saveObj: any = {
                old: this.oldArr,
                new: this.tempArr,
                model: attrs.selectArr
            };
            if ($scope.saveFunc !== undefined) {
                $scope.saveFunc({args: saveObj});
            }
            // $element.removeClass('active');
        };

        $scope.removeItem = function (i: number): any {
            this.oldArr = angular.copy($scope.selectArr);
            $scope.selectArr.splice(i, 1);
            var saveObj: any = {
                old: this.oldArr,
                new: $scope.selectArr,
                model: attrs.selectArr
            };
            if($scope.saveFunc !== undefined){
                $scope.saveFunc({args: saveObj});
            }
            // $element.removeClass('active');
        };

        $scope.undo = function (): any {
            // $element.removeClass('active');
        };
    }

    public static DirectiveFn($timeout: any): InlineEditMultipleDropdownDirective {
        return new InlineEditMultipleDropdownDirective($timeout);
    }
}

InlineEditMultipleDropdownDirective.DirectiveFn.$inject = ['$timeout'];

angular.module('beneple.global').directive('inlineEditMultipleDropdown', InlineEditMultipleDropdownDirective.DirectiveFn);



// WEBPACK FOOTER //
// ./frontend/scripts/global/directives/inline_edit_multiple_dropdown.directive.ts